export const managerPermission = (permission, bpSettings) => {
  const permissions = [
    {
      value: "dashboardCollectionData",
      label: "dashboardCollectionData",
      isChecked: permission?.dashboardCollectionData || false,
      disabled: false,
    },
    {
      value: "customerAdd",
      label: "customerAdd",
      isChecked: permission?.customerAdd || false,
      disabled: false,
    },
    {
      value: "customerEdit",
      label: "customerEdit",
      isChecked: permission?.customerEdit || false,
      disabled: false,
    },
    {
      value: "customerDelete",
      label: "customerDelete",
      isChecked: permission?.customerDelete || false,
      disabled: false,
    },
    // {
    //   value: "mobileNumberUpdate",
    //   label: "mobileNumberUpdate",
    //   isChecked: permission?.mobileNumberUpdate || false,
    //   disabled: false,
    // },
    // {
    //   value: "nameUpdate",
    //   label: "nameUpdate",
    //   isChecked: permission?.nameUpdate || false,
    //   disabled: false,
    // },
    // {
    //   value: "pppoeNameUpdate",
    //   label: "pppoeNameUpdate",
    //   isChecked: permission?.pppoeNameUpdate || false,
    //   disabled: false,
    // },
    {
      value: "billingCycleUpdate",
      label: "billingCycleUpdate",
      isChecked: permission?.billingCycleUpdate || false,
      disabled: false,
    },
    // {
    //   value: "promiseDateUpdate",
    //   label: "promiseDateUpdate",
    //   isChecked: permission?.promiseDateUpdate || false,
    //   disabled: false,
    // },
    {
      value: "customerActivate",
      label: "customerActivate",
      isChecked: permission?.customerActivate || false,
      disabled: false,
    },
    {
      value: "customerDeactivate",
      label: "customerDeactivate",
      isChecked: permission?.customerDeactivate || false,
      disabled: false,
    },
    {
      value: "monthlyFeeEdit",
      label: "monthlyFeeEdit",
      isChecked: permission?.monthlyFeeEdit || false,
      disabled: false,
    },
    {
      value: "updateCustomerBalance",
      label: "updateCustomerBalance",
      isChecked: permission?.updateCustomerBalance || false,
      disabled: false,
    },
    {
      value: "billPosting",
      label: "billPosting",
      isChecked: permission?.billPosting || false,
      disabled: false,
    },
    {
      value: "billDiscount",
      label: "billDiscount",
      isChecked: permission?.billDiscount || false,
      disabled: false,
    },
    {
      value: "instantRechargeBillPrint",
      label: "instantRechargeBillPrint",
      isChecked: permission?.instantRechargeBillPrint || false,
      disabled: !bpSettings?.instantRechargeBillPrint,
    },
    {
      value: "bulkAreaEdit",
      label: "bulkAreaEdit",
      isChecked: permission?.bulkAreaEdit || false,
      disabled: !bpSettings?.bulkAreaEdit,
    },
    {
      value: "bulkStatusEdit",
      label: "bulkStatusEdit",
      isChecked: permission?.bulkStatusEdit || false,
      disabled: !bpSettings?.bulkStatusEdit,
    },
    {
      value: "bulkBillingCycleEdit",
      label: "bulkBillingCycleEdit",
      isChecked: permission?.bulkBillingCycleEdit || false,
      disabled: !bpSettings?.bulkBillingCycleEdit,
    },
    {
      value: "bulkPromiseDateEdit",
      label: "bulkPromiseDateEdit",
      isChecked: permission?.bulkPromiseDateEdit || false,
      disabled: !bpSettings?.bulkPromiseDateEdit,
    },
    {
      value: "bulkAutoDisableEdit",
      label: "bulkAutoDisableEdit",
      isChecked: permission?.bulkAutoDisableEdit || false,
      disabled: !bpSettings?.bulkAutoDisableEdit,
    },
    {
      value: "bulkPackageEdit",
      label: "bulkPackageEdit",
      isChecked: permission?.bulkPackageEdit || false,
      disabled: !bpSettings?.bulkPackageEdit,
    },
    {
      value: "bulkTransferToReseller",
      label: "bulkCustomerTransferToReseller",
      isChecked: permission?.bulkTransferToReseller || false,
      disabled: !bpSettings?.bulkTransferToReseller,
    },
    {
      value: "bulkCustomerDelete",
      label: "bulkCustomerDelete",
      isChecked: permission?.bulkCustomerDelete || false,
      disabled: !bpSettings?.bulkCustomerDelete,
    },
    {
      value: "bulkCustomerMikrotikUpdate",
      label: "bulkCustomerMikrotikUpdate",
      isChecked: permission?.bulkCustomerMikrotikUpdate || false,
      disabled: !bpSettings?.bulkCustomerMikrotikUpdate,
    },
    {
      value: "bulkCustomerRecharge",
      label: "bulkCustomerRecharge",
      isChecked: permission?.bulkCustomerRecharge || false,
      disabled: !bpSettings?.bulkCustomerRecharge,
    },
    {
      value: "bulkPaymentStatusEdit",
      label: "bulkPaymentStatusEdit",
      isChecked: permission?.bulkPaymentStatusEdit || false,
      disabled: false,
    },
    {
      value: "customerInvoice",
      label: "customerInvoice",
      isChecked: permission?.customerInvoice || false,
      disabled: !bpSettings?.customerInvoice,
    },
    {
      value: "reportDelete",
      label: "billReportDelete",
      isChecked: permission?.reportDelete || false,
      disabled: !bpSettings?.reportDelete,
    },
    {
      value: "collectorAdd",
      label: "collectorAdd",
      isChecked: permission?.collectorAdd || false,
      disabled: false,
    },
    {
      value: "collectorEdit",
      label: "collectorEdit",
      isChecked: permission?.collectorEdit || false,
      disabled: false,
    },
    {
      value: "viewCollectorReport",
      label: "viewCollectorReport",
      isChecked: permission?.viewCollectorReport || false,
      disabled: false,
    },
    {
      value: "staffSalary",
      label: "staffSalary",
      isChecked: permission?.staffSalary || false,
      disabled: false,
    },
    {
      value: "sendSMS",
      label: "sendSMS",
      isChecked: permission?.sendSMS || false,
      disabled: false,
    },
    {
      value: "readMessageLog",
      label: "messageLog",
      isChecked: permission?.readMessageLog || false,
      disabled: false,
    },
    {
      value: "package",
      label: "customerPackageUpdate",
      isChecked: permission?.package || false,
      disabled: false,
    },
    {
      value: "supportTicketCategory",
      label: "supportTicketCategory",
      isChecked: permission?.supportTicketCategory || false,
      disabled: false,
    },
    {
      value: "expenditureDelete",
      label: "expenditureDelete",
      isChecked: permission?.expenditureDelete || false,
      disabled: !bpSettings?.expenditureDelete,
    },
    {
      value: "expenditureUpdate",
      label: "expenditureUpdate",
      isChecked: permission?.expenditureUpdate || false,
      disabled: false,
    },
    {
      label: "oltUserMonitor",
      value: "oltUserMonitor",
      isChecked: permission?.oltUserMonitor,
      disabled: !bpSettings?.oltUserMonitor,
    },
    {
      label: "webhookMessageLog",
      value: "webhookMessageLog",
      isChecked: permission?.webhookMessageLog,
      disabled: false,
    },
    {
      label: "ipnMessageLog",
      value: "ipnMessageLog",
      isChecked: permission?.ipnMessageLog,
      disabled: false,
    },
  ];

  return permissions;
};
